/* eslint-disable */
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';

import {
  TGetRatingListModel,
  IGetRatingListRequest,
  TGetRatingListResponse,
} from './types';

const defaultConfig: TGetRatingListModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'backend-content',
  pathApi: '/v1/get-specialist-rating-list',
  hostType: 'api',
};

function createGetRatingListModel(parameters: IGetRatingListRequest): TGetRatingListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetRatingListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetRatingListRequest;
  config?: IHttpApiFetchConfig;
}

async function fetchGetRatingList<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
}: IGetRatingListOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetRatingListResponse
  > {
  return await httpApi.fetch(createGetRatingListModel(parameters), { ...config, requestConfig: { withCredentials: true } });
}

export { defaultConfig, createGetRatingListModel, fetchGetRatingList };
